import { CSSProperties } from "react";
import { User } from "../../models/user";
// import { User } from "src/types/shared";
// import { states } from "../utils/state";

export const limitText = (text: string | undefined, limit: number) =>
  text ? (text?.length > limit ? text.slice(0, limit) + "..." : text) : text;

// export const statesOptions = states.map((state) => ({
//   value: state.name.toLowerCase(),
//   label: state.name,
// }));

export const dateLocale = (date: Date | string) => {
  const conv = new Date(date);
  return conv.toLocaleDateString("en", {
    day: "2-digit",
    month: "numeric",
    year: "numeric",
  });
};

export const dateTimeLocale = (date: Date | string) => {
  const conv = new Date(date);
  return conv.toLocaleString("en", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const localeDate = (value: string | number | Date) => {
  const date = new Date(value);
  return date.toLocaleDateString();
};

export const getInitials = (user?: Partial<User>) => {
  if (user?.username && user.displayName)
    return `${
      user.username.split("").find((char, index) => index === 0) || ""
    } ${user.displayName.split("").find((char, index) => index === 0) || ""}`;
  else if (user?.username) {
    return user.username
      .split(" ")
      .map((name) => name.charAt(0).toUpperCase())
      .join(" ");
  }
};

export type StatusCode = 0 | 1 | 2 | 3 | 4 | 5 | number;

export const codeToStatus: (code: StatusCode) => {
  text: string;
  style: CSSProperties;
} = (code) =>
  code === 0 || code === 4
    ? {
        text: "In Progress",
        style: { backgroundColor: "#E2E5E3", color: "#344437" },
      }
    : code === 2
    ? {
        text: "Completed",
        style: { backgroundColor: "#F3FFF3", color: "#36B44A" },
      }
    : code === 5
    ? {
        text: "Cancelled",
        style: { backgroundColor: "#FCDEE4", color: "#CD2B65" },
      }
    : {
        text: "In Progress",
        style: { backgroundColor: "#E2E5E3", color: "#344437" },
      };

export const getDateInMs = (date: Date | string) => new Date(date).getTime();

export default class responseCodes {
  static response_99 = "99"; //error
  static response_00 = "00"; //success
  static response_401 = 401; //unauthorized
  static response_500 = 500; //server error
  static response_05 = "05"; //
  static response_04 = "04"; //
  static response_03 = "03"; //
  static response_01 = "01"; //
}
export const handleStateChange = (setState: any, name: string, e: any) => {
  const value = e.target.value;
  const clean = value.replace(/,/g, "");
  const regex = /^[0-9]*\.?[0-9]*$/;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  });

  if (value && clean.match(regex)) {
    if (!value.includes(".")) {
      const formatted = formatter.format(parseFloat(clean));
      // setDisplayVal(formatted);
      setState(name, formatted);
    } else {
      const parts = value.split(".");
      const newclean = parts[0].replace(/,/g, "");
      const formatted = formatter.format(parseFloat(newclean));
      const returnValue = formatted + "." + parts[1];
      setState(name, returnValue);
    }
  } else {
    // setDisplayVal("");
    setState(name, "");
  }
};

export const handleStateChange2 = (setState: any, name: string, e: any) => {
  const value = e.target.value;
  const clean = value.replace(/,/g, ""); // Clean the input value by removing commas
  const regex = /^[0-9]+(\.[0-9]{0,2})?$/; // Regex to allow numbers with up to 2 decimals

  if (value && clean.match(regex)) {
    // Check if there's no decimal point and the value is non-zero
    if (!value.includes(".")) {
      const formatted = new Intl.NumberFormat().format(parseFloat(clean));
      setState(name, formatted); // Update state with formatted value
    } else {
      setState(name, value); // Allow decimal input
    }
  } else {
    setState(name, ""); // Reset state if the value doesn't match regex
  }
};


export const handleStateChange3 = (value: any) => {
  const clean = value.replace(/,/g, "");
  const regex = /^[0-9]*\.?[0-9]*$/;

  if (value && clean.match(regex)) {
    if (value.includes(".")) {
      return;
    }
    if (!value.includes(".")) {
      const formatted = new Intl.NumberFormat().format(parseFloat(clean));
      return formatted;
    } else {
      // setDisplayVal(value);
      return value;
    }
  } else {
    return "";
  }
};

export const handleStateChange4 = (value: any) => {
  const clean = value.replace(/,/g, "");
  const regex = /^[0-9]*\.?[0-9]*$/;

  if (value && clean.match(regex)) {
    if (!value.includes(".")) {
      const formatted = new Intl.NumberFormat().format(parseFloat(clean));
      return formatted;
    } else {
      const parts = value.split(".");
      const newclean = parts[0].replace(/,/g, "");
      const formatted = new Intl.NumberFormat().format(parseFloat(newclean));
      const returnValue = formatted + "." + parts[1];
      return returnValue;
    }
  } else {
    return "";
  }
};

export function formatCurrency(number: string) {
  try {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
    });
    const parts = number.split(".");
    let interPartFormat = parts[0].replace(/,/g, "");

    if (isNaN(Number(interPartFormat))) {
      return "";
    }

    let interPart = formatter.format(Number.parseFloat(interPartFormat));

    if (Number.parseFloat(interPart) <= 0) {
      return "";
    }

    if (parts.length > 1) {
      return interPart + "." + parts[1].slice(0, 2);
    } else {
      return interPart;
    }
  } catch (error) {
    return number;
  }
}

export const handleStateDecimalToPrice = (setState: any, name: string, e: any) => {
  const value = e.target.value;
  const clean = value.replace(/,/g, ""); 
  const regex = /^[0-9]+(\.[0-9]{0,2})?$/;

  if (!value) {
    setState(name, ""); 
  } else if (clean.match(regex)) {
    if (value.includes(".")) {
      // Ensure the decimal value is correctly formatted
      const formatted = new Intl.NumberFormat().format(parseFloat(clean));
      setState(name, formatted);
    } else {
      // If no decimal is entered and value is non-zero, add ".00"
      const formatted = clean !== "0" && clean !== "" 
        ? new Intl.NumberFormat().format(parseFloat(clean)) + ".00" 
        : new Intl.NumberFormat().format(parseFloat(clean));
      setState(name, formatted);
    }
  } else {
    setState(name, ""); // If the input is invalid, reset the state
  }
};

export const handlePhoneNumber = (setState: any, name: string, e: any) => {
  const value = e.target.value;
  const clean = value.replace(/\D/g, ""); // Remove non-digit characters
  const regex = /^[0-9]{9,11}$/; // Check if it's exactly 10 digits (US phone number length)

  if (clean.match(regex)) {
    // If the input has exactly 10 digits, format it
    const formatted = clean;
    setState(name, formatted);
  } else {
    // If the input is not valid, set the state to an empty string or any default value
    setState(name, clean);
  }
};

export const handleAccountNumber = (setState: any, name: string, e: any) => {
  const value = e.target.value;
  const clean = value.replace(/\D/g, ""); // Remove non-digit characters
  const regex = /^[0-9]{10}$/; // Check if it's exactly 10 digits (US phone number length)

  if (clean.match(regex)) {
    // If the input has exactly 10 digits, format it
    const formatted = clean;
    setState(name, formatted);
  } else {
    // If the input is not valid, set the state to an empty string or any default value
    setState(name, clean);
  }
};





